import algosdk from 'algosdk';
import AlgoSigner from './AlgoSigner';

const baseServer = 'https://testnet-algorand.api.purestake.io/ps2';
const port = '';

const token = {
  'X-API-Key': '7eTayusS6B7Ux0bjolKVA4xWwc3Ycy3o6sL7AF7k',
};


const client = new algosdk.Algodv2(token, baseServer, port);
const deposit_amount = 100000;

(window as any).global = window;
window.Buffer = window.Buffer || undefined;

export const readGlobalState = async (account: string, appID: any ) => {
  const applicationInfoResponse = await client.getApplicationByID(appID).do();
  let decimal = 0
  let price = 0;
  let globalState = [];
 
  globalState = applicationInfoResponse['params']['global-state']
  for (let n = 0; n < globalState.length; n++) {
    console.log(atob(globalState[n].key));
    if(atob(globalState[n].key) === 'decimals'){
      decimal = globalState[n].value.uint
    } else price = globalState[n].value.uint
  }

  return price / parseInt('1' + '0'.repeat(decimal));
}

/**
 * Creates a binary signed opt in transaction that is ready to be sent to the algorand network
 * @param {string} sender_address the address of the account that is opting in
 * @return {Promise<Uint8Array>} A byte array redy to be sent
 */
export const create_signed_opt_in_txn = async (
  sender_address: string,
  app_id: number
): Promise<Uint8Array> => {
  //build transaction
  const params = await client.getTransactionParams().do();
  //create unsigned txn
  const txn = algosdk.makeApplicationOptInTxn(sender_address, params, app_id);
  const binaryTx = txn.toByte();
  const base64Tx = AlgoSigner.encoding.msgpackToBase64(binaryTx);
  const signedTxn = await AlgoSigner.signTxn([{ txn: base64Tx }]);
  const binarySignedTx = AlgoSigner.encoding.base64ToMsgpack(signedTxn[0].blob);
  return binarySignedTx;
};

/**
 * Creates a binary signed opt out transaction that is ready to be sent to the algorand network
 * @param {string} sender_address the address of the account that is opting in
 * @return {Promise<Uint8Array>} A byte array redy to be sent
 */
export const create_signed_opt_out_txn = async (
  sender_address: string,
  app_id: number
): Promise<Uint8Array> => {
  //build transaction
  const params = await client.getTransactionParams().do();
  //create unsigned txn
  const txn = algosdk.makeApplicationCloseOutTxn(
    sender_address,
    params,
    app_id
  );
  const binaryTx = txn.toByte();
  const base64Tx = AlgoSigner.encoding.msgpackToBase64(binaryTx);
  const signedTxn = await AlgoSigner.signTxn([{ txn: base64Tx }]);
  const binarySignedTx = AlgoSigner.encoding.base64ToMsgpack(signedTxn[0].blob);
  return binarySignedTx;
};

/**
 * Creates a binary signed opt out transaction that is ready to be sent to the algorand network
 * @param {string} sender_address the address of the account that is opting in
 * @return {Promise<Uint8Array>} A byte array redy to be sent
 */
export const create_unsigned_opt_out_txn = async (
  sender_address: string,
  app_id: number
): Promise<algosdk.Transaction> => {
  //build transaction
  const params = await client.getTransactionParams().do();
  //create unsigned txn
  const txn = algosdk.makeApplicationCloseOutTxn(
    sender_address,
    params,
    app_id
  );
  // const binaryTx = txn.toByte();
  // const base64Tx = AlgoSigner.encoding.msgpackToBase64(binaryTx);
  // const signedTxn =  await AlgoSigner.signTxn([{txn: base64Tx}]);
  // const binarySignedTx = AlgoSigner.encoding.base64ToMsgpack(signedTxn[0].blob);
  return txn;
};

export const send_txn = async (signedTxn: Uint8Array) => {
  const txn_id = await client.sendRawTransaction(signedTxn).do();
  return txn_id;
};

export const create_unsigned_pymnt_txn = async (
  sender_address: string,
  app_id: number,
  receiver: string | undefined
) => {
  const params = await client.getTransactionParams().do();

  //create unsigned txn
  const pymnt_txn_unsigned = algosdk.makePaymentTxnWithSuggestedParams(
    sender_address,
    receiver ? receiver : algosdk.getApplicationAddress(app_id),
    deposit_amount,
    undefined,
    undefined,
    params,
    undefined
  );

  // const binaryTx = pymnt_txn_unsigned.toByte();
  // const base64Tx = AlgoSigner.encoding.msgpackToBase64(binaryTx);

  return pymnt_txn_unsigned;
};

const create_base64_tx = (txn: any) => {
  const binaryTx = txn.toByte();
  const base64Tx = AlgoSigner.encoding.msgpackToBase64(binaryTx);
  return base64Tx;
};

export const create_signed_txn_group = async (txns: any) => {
  algosdk.assignGroupID(txns);
  const formattedTxns = txns.map((txn: any) => {
    return { txn: create_base64_tx(txn) };
  });

  const signedTxns = await AlgoSigner.signTxn(formattedTxns);
  const binaryTxns = signedTxns.map((txn: any) => {
    return AlgoSigner.encoding.base64ToMsgpack(txn.blob);
  });
  return await binaryTxns;
};

export const create_unsigned_app_call = async (
  sender_address: string,
  args: any,
  app_id: number
) => {
  const params = await client.getTransactionParams().do();
  const unsigned_app_call = algosdk.makeApplicationNoOpTxn(
    sender_address,
    params,
    app_id,
    args
  );
  // const binaryTx = unsigned_app_call.toByte();
  // const base64Tx = AlgoSigner.encoding.msgpackToBase64(binaryTx);
  return unsigned_app_call;
};

/**
 * Wait until the transaction is confirmed or rejected, or until 'timeout'
 * number of rounds have passed.
 * @param {string} txId the transaction ID to wait for
 * @param {number} timeout maximum number of rounds to wait
 * @return {Promise<*>} pending transaction information
 * @throws Throws an error if the transaction is not confirmed or rejected in the next timeout rounds
 */
export const waitForConfirmation = async function (
  txId: string,
  timeout: number
) {
  if (client == null || txId == null || timeout < 0) {
    throw new Error('Bad arguments');
  }

  const status = await client.status().do();
  if (status === undefined) {
    throw new Error('Unable to get node status');
  }

  const startround = status['last-round'] + 1;
  let currentround = startround;

  while (currentround < startround + timeout) {
    const pendingInfo = await client.pendingTransactionInformation(txId).do();
    if (pendingInfo !== undefined) {
      if (
        pendingInfo['confirmed-round'] !== null &&
        pendingInfo['confirmed-round'] > 0
      ) {
        //Got the completed Transaction
        return pendingInfo;
      } else {
        if (
          pendingInfo['pool-error'] != null &&
          pendingInfo['pool-error'].length > 0
        ) {
          // If there was a pool error, then the transaction has been rejected!
          throw new Error(
            'Transaction ' +
              txId +
              ' rejected - pool error: ' +
              pendingInfo['pool-error']
          );
        }
      }
    }
    await client.statusAfterBlock(currentround).do();
    currentround++;
  }
  throw new Error(
    'Transaction ' + txId + ' not confirmed after ' + timeout + ' rounds!'
  );
};

export const connect_algosigner = (): [] | undefined => {
  try {
    if (AlgoSigner) {
      AlgoSigner.connect().then(async () => {
        const accts = await AlgoSigner.accounts({ ledger: 'TestNet' });
        return accts;
      });
    }
    return [];
  } catch (error) {
    return [];
  }
};
